import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import type {App} from 'vue'

interface AxiosOptions {
    baseUrl?: string
    headers?: {}
    startLoader?: (key: string) => void
    stopLoader?: (key: string) => void
    crashManager?: (error: string) => void
    unauthorizedManager?: (error: string) => void
}

function getJsonObj(input: any): any {
    try {
        return JSON.parse(input)
    } catch (e) {
        return input
    }
}

function getKeyRequest(request: AxiosRequestConfig): string {
    try {
        const key = `${request.url}${JSON.stringify(request.params ?? '')}${JSON.stringify(getJsonObj(request.data) ?? '')}`
        return clearString(key)
    } catch (e) {
        return clearString(`${request.url}`)
    }
}

function clearString(text: string): string {
    const utf8Bytes = new TextEncoder().encode(text)
    return btoa(String.fromCharCode(...utf8Bytes))
}

export default {
    install: (app: App, options: AxiosOptions) => {
        app.config.globalProperties.$axios = axios.create({
            baseURL: options.baseUrl,
            headers: options.headers ?? {},
            withCredentials: true
        })
        if(options.startLoader !== undefined && options.stopLoader !== undefined){
            app.config.globalProperties.$axios.interceptors.request.use(function (config: AxiosRequestConfig) {
                options.startLoader?.(getKeyRequest(config));
                return config;
            }, function (error: AxiosError) {
                if(error.config?.url !== undefined){
                    options.stopLoader?.(getKeyRequest(error.config));
                }else{
                    options.crashManager?.(error.message)
                }
                return Promise.reject(error);
            });

            app.config.globalProperties.$axios.interceptors.response.use
            (
              (response: AxiosResponse) => {
                  options.stopLoader?.(getKeyRequest(response.config));
                  return response;
              },
              (error: any) => {
                  if (error.response?.status === 401 && !!options.unauthorizedManager) {
                      options.unauthorizedManager(error.message)
                  }
                  if(error.config?.url !== undefined){
                      options.stopLoader?.(getKeyRequest(error.config));
                  }else{
                      options.crashManager?.(error.message)
                  }
                  return Promise.reject(error);
              }
            );
        }
    }
}
